// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Berw","content":"styles_content__3Ytse","tableWrap":"styles_tableWrap__ac_B-"};